var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import './lib.legacy';
import * as error from './error';
import env from '../../core/env';
import { ge } from '../../utils/semver';
// @ts-ignore
import { call as newCall } from '@bridge/byted-bridge-jssdk';
// 桥是否初始化
var isInited = false;
// 桥是否就绪
var isReady = false;
// 桥在当前环境是否可用
var isAvailable = true;
// 已注册的api集合
var apis = {};
var queue = [];
// api调用结果缓存
var cachedResult = {};
// 桥的底层实现，主要包含iframe消息逻辑
var bridge = window.ToutiaoJSBridge;
if (env.isInSuper) {
    bridge = window.JSBridge;
}
/**
 * 注册/添加 api
 * @param {string} api.name api的名称
 * @param {string|function} api.handle 传递给客户端的api句柄名称(或者转换函数), 缺省为 api.name
 * @oaram {function|any} api.options 传递给客户端的参数(或者转换函数)
 * @param {function} api.supports 当前api是否可用, 默认true
 */
export function register(entry) {
    var api = (apis[entry.name] = __assign({}, entry));
    // eslint-disable-next-line no-shadow
    var handle = api.handle, options = api.options, supports = api.supports;
    if (typeof handle !== 'function') {
        api.handle = function () { return handle || api.name; };
    }
    if (typeof options !== 'function') {
        api.options = function (runtime) { return options || runtime; };
    }
    if (typeof supports !== 'function') {
        api.supports = function () { return supports !== false; };
    }
}
/**
 * 判断当前环境中桥功能以及该api是否可用，
 * 可用则执行对应的api处理函数，不可用则reject对应的错误
 */
export function exec(_a) {
    var api = _a.api, cb = _a.cb, resolve = _a.resolve, reject = _a.reject;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            if (!isAvailable) {
                reject(error.notAvailable());
                return [2 /*return*/];
            }
            try {
                // eslint-disable-next-line no-use-before-define
                if (api.supports(env)) {
                    cb(api, resolve, reject);
                }
                else {
                    reject(error.notSupported(api.name));
                }
            }
            catch (e) {
                reject(error.notSupported(api.name));
            }
            return [2 /*return*/];
        });
    });
}
function isHostInWhitelist() {
    var host = window.location.host;
    if (/(toutiao|snssdk)\.com/i.test(host)) {
        return true;
    }
    if (/jinritemai\.com/i.test(host)) {
        if (env.isInAweme && ge(env.appVersion, '2.6.0')) {
            return true;
        }
        if (env.isInToutiao) {
            return true;
        }
    }
    return false;
}
/**
 * 配置桥
 */
// eslint-disable-next-line prettier/prettier
export function config(options) {
    if (options === void 0) { options = {}; }
    if (isInited)
        return;
    isInited = true;
    var _a = options.maxAttempts, maxAttempts = _a === void 0 ? 3 : _a;
    var settle = function (available) {
        isReady = true;
        isAvailable = available;
        queue.splice(0).forEach(exec);
    };
    var auth = function (attempts) {
        if (attempts > maxAttempts) {
            settle(false);
        }
        else {
            window.toutiao.config({
                client_id: '79de2e25923597ec',
                success: function () { return settle(true); },
                error: function () { return auth(attempts + 1); }
            });
        }
    };
    if (!env.isInToutiaoProduct) {
        settle(false);
    }
    else if (typeof options.supports === 'function') {
        settle(options.supports(env));
    }
    else if (isHostInWhitelist()) {
        settle(true);
    }
    else {
        auth(1);
    }
}
/**
 * 所有api调用都通过ready进行调度,
 * 如果api不存在则 默认支持调用
 * 如果桥未ready则入队列, 否则通过exec执行回调
 *
 * @param {string} apiName api名称
 * @param {Object} params 传递给api调用的参数
 * @param {function} cb 回调，负责api的实际调用
 */
export function ready(apiName, params, cb) {
    if (!isInited)
        config();
    return new Promise(function (resolve, reject) {
        // 给未注册的api一个默认值
        if (!apis[apiName]) {
            register({
                name: apiName,
                handle: apiName,
                supports: function () { return true; }
            });
            // reject(error.notExist(apiName));
        }
        var api = apis[apiName];
        if (!isReady) {
            queue.push({ api: api, params: params, cb: cb, resolve: resolve, reject: reject });
        }
        else {
            exec({ api: api, params: params, cb: cb, resolve: resolve, reject: reject });
        }
    });
}
/**
 * @returns {boolean} 判断jsbridge是否可用
 */
export function supports(apiName) {
    var api = apis[apiName];
    // eslint-disable-next-line no-use-before-define
    return api && api.supports(env);
}
/**
 * 调用api
 * @param {string} apiName api的名称
 * @param {Object} params api调用参数
 * @param {Object} opts 配置选项
 * @param {boolean} opts.cache=false 是否缓存结果
 * @param {number} opts.timeout 超时时间
 * @return {Promise} 调用结果
 */
export function call(apiName, params, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = opts.cache, cache = _a === void 0 ? false : _a, _b = opts.timeout, timeout = _b === void 0 ? 0 : _b;
    return ready(apiName, params, function (api, resolve, reject) {
        if (cache && cachedResult[apiName]) {
            resolve(cachedResult[apiName]);
        }
        else {
            var handle = api.handle(env);
            var options = api.options(params);
            var onTimeout = function () { return reject(error.timeout(apiName)); };
            var timeoutId_1 = timeout > 0 ? setTimeout(onTimeout, timeout) : 0;
            var callFn = opts.version === 2 ? newCall : bridge.call;
            callFn(handle, options, function (raw) {
                var result = raw;
                if (typeof raw === 'string') {
                    try {
                        result = JSON.parse(raw);
                    }
                    catch (e) {
                        //
                    }
                }
                // 由于桥回调结果格式不统一,
                // 这里不对客户端返回的结果做校验，全部resolve
                // 具体业务上是成功还是失败，需要业务自己判断
                resolve(result);
                if (timeoutId_1)
                    clearTimeout(timeoutId_1);
                if (cache)
                    cachedResult[apiName] = result;
            });
        }
    });
}
// 监听客户端事件，如 visible
export function listen(apiName, cb) {
    // eslint-disable-next-line no-undefined
    return ready(apiName, undefined, function (api) {
        bridge.on(api.handle(env), cb);
    });
}
